import { Services } from '@sigma-frontend-libs/commons'
import { isUUID } from '@sigmasms/commons'

import render from './render'

export default {
  name: 'SecondCol',

  props: {
    value: null,

    service: {
      type: String,
      validator: value => {
        return Object.values(Services).includes(value)
      }
    },

    id: {
      type: String,
      validator: isUUID
    }
  },

  render
}
